import React, { useState } from "react";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

function InstallmentModal({ show, handleClose, beneficiary, onSuccess }) {
  const [installment, setInstallment] = useState("");
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [remark, setRemark] = useState(""); // New state for remark

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  const getAvailableInstallments = () => {
    const paidInstallments = [];
    for (let i = 1; i <= 5; i++) {
      const suffix = i === 1 ? "st" : i === 2 ? "nd" : i === 3 ? "rd" : "th";
      const amountKey = `${i}${suffix}_installment_amount`;
      const dateKey = `${i}${suffix}_installment_date`;
      // Consider an installment as paid if it has either amount or date
      if (beneficiary[amountKey] || beneficiary[dateKey]) {
        paidInstallments.push(i);
      }
    }
    return [1, 2, 3, 4, 5].filter((inst) => !paidInstallments.includes(inst));
  };

  const availableInstallments = getAvailableInstallments();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!installment || !amount || !date) {
      toast.error(
        "Please select an installment, enter an amount, and select a date."
      );
      return;
    }

    const suffix =
      installment == 1
        ? "st"
        : installment == 2
        ? "nd"
        : installment == 3
        ? "rd"
        : "th";

    const payload = {
      id: beneficiary.id,
      [`${installment}${suffix}_installment`]: `${installment}${suffix}_installment`,
      [`${installment}${suffix}_installment_amount`]: amount,
      [`${installment}${suffix}_installment_date`]: date,
      [`${installment}${suffix}_installment_remark`]: remark, // Add remark to payload
    };
    // console.log(payload);

    try {
      const response = await axios.post(
        `${API_URL}/update-installment.php`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data.success) {
        console.log(response);
        toast.success("Installment added successfully!");
        onSuccess();
      } else {
        toast.error(response.data.message || "Failed to add installment.");
      }
    } catch (error) {
      toast.error("An error occurred while adding the installment.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Add Installment for {beneficiary.Beneficiary_name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <p>
            <strong>Beneficiary Code:</strong> {beneficiary.Beneficiary_code}
          </p>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Select Installment</strong>
                </Form.Label>
                <Form.Select
                  value={installment}
                  onChange={(e) => setInstallment(e.target.value)}
                  required
                >
                  <option value="">Choose...</option>
                  {availableInstallments.map((inst) => (
                    <option key={inst} value={inst}>
                      {inst}
                      {inst === 1
                        ? "st"
                        : inst === 2
                        ? "nd"
                        : inst === 3
                        ? "rd"
                        : "th"}{" "}
                      Installment
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Amount</strong>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Date</strong>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Remark</strong>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Add a remark (optional)"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end mt-3">
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Cancel
            </Button>
            <Button
              variant="success"
              type="submit"
              disabled={availableInstallments.length === 0}
            >
              {availableInstallments.length > 0
                ? "Add Installment"
                : "All Paid"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default InstallmentModal;
